import { LINEAREALTIME} from './LineaRealTimeTypes'

const initialState = {
    lineaRealTime: ""
}

const LineaRealTimeReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case LINEAREALTIME:
            
            return {
                lineaRealTime: action.load
            }
    
        default:
          return state
    }

}


export default  LineaRealTimeReducer;